import Fuse from 'fuse.js';

document.addEventListener('DOMContentLoaded', function () {
  // settings
  const maxProducts = 5;
  const maxTerms = 9;

  // init
  let isSearchReady = false;

  // main elements
  const main = document.querySelector('#main');
  const toggleElements = document.querySelectorAll('[data-search-toggle]');
  const toggleClass = 'is-search-open';

  // product elements
  const productTemplate = document.querySelector(
    '[data-search-product-template]'
  );
  const productTemplateContent = productTemplate.innerHTML;
  const productsTitle = document.querySelector('[data-search-products-title]');
  const productsBrand = document.querySelector('[data-search-product-brand]');
  const productsDefault = document.querySelector(
    '[data-search-products-default]'
  );
  const productsList = document.querySelector('[data-search-products]');

  // term elements
  const termTemplate = document.querySelector('[data-search-term-template]');
  const termTemplateContent = termTemplate.innerHTML;
  const termsTitle = document.querySelector('[data-search-terms-title]');
  const termsDefault = document.querySelector('[data-search-terms-default]');
  const termsList = document.querySelector('[data-search-terms]');

  // search elements
  const search = document.querySelector('[data-search]');
  const searchBg = document.querySelector('[data-search-bg]');
  const searchMain = document.querySelector('[data-search-main]');
  const searchAside = document.querySelector('[data-search-aside]');
  const searchInput = document.querySelector(
    '[data-search-input][data-id="search-hero"]'
  );

  // indexes
  let terms = [];
  let products = [];

  function checkSearchReady() {
    if (terms.length > 0 && products.length > 0) {
      isSearchReady = true;
    }
    if (isSearchReady) {
      initSearch();
    }
  }

  // load indexes
  function loadIndexes() {
    fetch('/actions/pro/search/get-products-index')
      .then((response) => response.json())
      .then((data) => {
        products = data;
        checkSearchReady();
      });
    fetch('/actions/pro/search/get-terms-index')
      .then((response) => response.json())
      .then((data) => {
        terms = data;
        checkSearchReady();
      });
  }

  // toggle search mode
  function toggleSearchMode() {
    main.classList.toggle(toggleClass);
    if (main.classList.contains(toggleClass)) {
      ensureIndexes();
      if (searchInput) {
        searchInput.focus();
      }
      main.classList.remove('is-menu-open');
    }
  }

  // toggle search mode elements
  toggleElements.forEach(function (el) {
    el.addEventListener('click', function () {
      toggleSearchMode();
    });
  });

  // close search on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && main.classList.contains(toggleClass)) {
      toggleSearchMode();
    }
  });

  // resize search background
  function resizeSearchBg() {
    if (searchBg) searchBg.style.height = search.offsetHeight + 'px';
  }

  function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function getQueryTerms(query) {
    return query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  }

  function getHighlightRegex(query) {
    const terms = getQueryTerms(query).map(escapeRegExp);

    return terms.length ? new RegExp(`(${terms.join('|')})`, 'ig') : null;
  }

  function searchByTerms(fuse, key, query) {
    const terms = getQueryTerms(query);

    if (terms.length <= 1) {
      return fuse.search(query);
    }

    return fuse.search({
      $and: terms.map((term) => ({
        [key]: term,
      })),
    });
  }

  // render products
  function renderProducts(matches) {
    productsList.innerHTML = '';
    const query = searchInput.value.trim().toLowerCase();
    const limitedMatches = matches.slice(0, maxProducts);

    limitedMatches.forEach((match) => {
      const title = match.title;
      const brand = match.brand;
      const url = match.url;
      const imageUrl = match.imageUrl;
      const price = match.price;
      const regex = getHighlightRegex(query);
      const el = productTemplate.cloneNode(true);
      el.removeAttribute('data-search-product-template');
      el.querySelector('[data-search-product-title]').innerHTML = title.replace(
        regex,
        '<mark>$1</mark>'
      );
      el.querySelector('[data-search-product-brand]').innerHTML = brand.replace(
        regex,
        '<mark>$1</mark>'
      );
      el.href = url;
      el.querySelector('[data-search-product-price]').innerHTML = price;
      if (imageUrl) {
        el.querySelector('[data-search-product-image]').src = imageUrl;
      } else {
        el.querySelector('[data-search-product-image]').style.display = 'none';
      }
      el.style.display = null;
      // el.addEventListener('click', () => {
      //   searchInput.value = title;
      //   clearProducts();
      // });
      productsList.appendChild(el);
    });

    if (limitedMatches.length === 0) {
      expandAside();
    } else {
      collapseAside();
    }

    // if (limitedMatches.length === 0) hideProducts();
    // else showProducts();
    showProducts();

    resizeSearchBg();
  }

  // clear products
  function clearProducts() {
    productsList.innerHTML = '';
    collapseAside();
    hideProducts();
  }

  // show products
  function showProducts() {
    if (productsList && productsList.innerHTML.length > 0) {
      productsList.style.display = 'flex';
      if (productsTitle)
        productsTitle.innerHTML = productsTitle.getAttribute('data-results');
      if (productsDefault) productsDefault.style.display = 'none';
    }
  }

  // hide products
  function hideProducts() {
    if (productsList) {
      productsList.style.display = 'none';
    }
    if (productsTitle)
      productsTitle.innerHTML = productsTitle.getAttribute('data-default');
    if (productsDefault) productsDefault.style.display = 'flex';
    resizeSearchBg();
  }

  // expand aside
  function expandAside() {
    if (searchMain) searchMain.style.display = 'none';
    if (searchAside) searchAside.classList.add('site-search__aside--expanded');
  }

  // collapse aside
  function collapseAside() {
    if (searchMain) searchMain.style.display = '';
    if (searchAside)
      searchAside.classList.remove('site-search__aside--expanded');
  }

  // render terms
  function renderTerms(matches) {
    termsList.innerHTML = '';
    const query = searchInput.value.trim().toLowerCase();
    const limitedMatches = matches.slice(0, maxTerms);

    limitedMatches.forEach((match) => {
      const title = match.title;
      const url = match.url;
      const regex = getHighlightRegex(query);
      const el = termTemplate.cloneNode(true);
      el.querySelector('[data-search-term-title]').removeAttribute(
        'aria-hidden'
      );
      el.querySelector('[data-search-term-title]').innerHTML = title.replace(
        regex,
        '<mark>$1</mark>'
      );
      el.querySelector('[data-search-term-title]').href = url;
      el.style.display = null;
      // el.addEventListener('click', () => {
      //   searchInput.value = title;
      //   clearTerms();
      // });
      termsList.appendChild(el);
    });

    // add original term as last item
    const originalTerm = searchInput.value.trim().toLowerCase();
    const originalTermEl = termTemplate.cloneNode(true);
    originalTermEl.querySelector('[data-search-term-title]').innerHTML =
      originalTerm;
    originalTermEl.querySelector('[data-search-term-title]').href =
      '/products/search?keywords=' + originalTerm;
    originalTermEl.style.display = null;
    termsList.appendChild(originalTermEl);

    // if (limitedMatches.length === 0) hideTerms();
    // else showTerms();
    showTerms();

    resizeSearchBg();
  }

  // clear terms
  function clearTerms() {
    termsList.innerHTML = '';
    hideTerms();
  }

  // show terms
  function showTerms() {
    if (termsList && termsList.innerHTML.length > 0) {
      termsList.style.display = 'block';
      if (termsTitle)
        termsTitle.innerHTML = termsTitle.getAttribute('data-results');
      if (termsDefault) termsDefault.style.display = 'none';
    }
  }

  // hide terms
  function hideTerms() {
    if (termsList) {
      termsList.style.display = 'none';
    }
    if (termsTitle)
      termsTitle.innerHTML = termsTitle.getAttribute('data-default');
    if (termsDefault) termsDefault.style.display = 'block';
    resizeSearchBg();
  }

  // establish search functionality
  function initSearch() {
    // map the terms to the products
    const productsIndex = products.map(
      ([title, brand, searchTitle, url, imageUrl, price]) => ({
        title,
        brand,
        searchTitle,
        url,
        imageUrl,
        price,
      })
    );

    // init products fuse
    const productsFuse = new Fuse(productsIndex, {
      useExtendedSearch: true,
      threshold: 0.3,
      ignoreLocation: true,
      keys: [
        {
          name: 'searchTitle',
          weight: 1.0,
        },
      ],
    });

    // map the terms to the products
    const termsIndex = terms.map(([title, url]) => ({
      title,
      url,
    }));

    // init products fuse
    const termsFuse = new Fuse(termsIndex, {
      useExtendedSearch: true,
      threshold: 0.3,
      ignoreLocation: true,
      keys: [
        {
          name: 'title',
          weight: 1.0,
        },
      ],
    });

    // listen to the text input query
    searchInput.addEventListener('input', () => {
      // format the query
      const query = searchInput.value.trim().toLowerCase();
      if (query.length < 2) {
        clearProducts();
        clearTerms();
        return;
      }

      // search the products
      const productsResults = query
        ? searchByTerms(productsFuse, 'searchTitle', query).map(
            (result) => result.item
          )
        : [];
      renderProducts(productsResults);

      // search the terms
      const termsResults = query
        ? searchByTerms(termsFuse, 'title', query).map((result) => result.item)
        : [];
      renderTerms(termsResults);
    });

    if (searchInput.value.trim().length >= 2) {
      searchInput.dispatchEvent(new Event('input'));
    }
  }

  let indexesRequested = false;

  function ensureIndexes() {
    if (indexesRequested) return;
    indexesRequested = true;
    loadIndexes();
  }

  // on init
  resizeSearchBg();

  if (searchInput) {
    searchInput.addEventListener('focus', ensureIndexes);
    searchInput.addEventListener('input', ensureIndexes);
  }

  // on resize
  window.addEventListener('resize', () => {
    resizeSearchBg();
  });

  // // Attach document click listener only once, outside the input loop
  // document.addEventListener('click', (e) => {
  //   if (!e.target.closest('[data-search-input-wrapper]')) {
  //     if (productsList) {
  //       productsList.style.display = 'none';
  //     }
  //   }
  // });
});
